import Vue from 'vue';
import Vuetify, { VSnackbar, VBtn, VIcon } from 'vuetify/lib'

const opts = {};
Vue.use(Vuetify, {
    components: {
      VSnackbar,
      VBtn,
      VIcon
    }
  })

export default new Vuetify(opts);